export default __webpack_public_path__ + "static/media/Connect-Vector.64c7f8c9.png";